import { motion } from "framer-motion";
import { Phone, MapPin, Star } from "lucide-react";
import { shop, images } from "../../data";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-36 md:pt-44 pb-20 md:pb-28 overflow-hidden"
    >
      {/* soft ambient blobs */}
      <div className="pointer-events-none absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-[#F2A0B4]/30 blur-3xl" />
      <div className="pointer-events-none absolute top-1/2 -left-40 w-[420px] h-[420px] rounded-full bg-[#F2A0B4]/20 blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center relative">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="lg:col-span-6"
        >
          <div className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#C24E77] mb-7">
            <span className="w-8 h-px bg-[#123D5B]" />
            Negozio storico a Novara
          </div>

          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-[#123D5B]">
            Il piacere di dormire
            <br />
            <span className="italic text-[#C24E77]">bene vestite.</span>
          </h1>

          <p className="mt-7 text-base md:text-lg text-[#4A5863] max-w-md leading-relaxed">
            Pigiami, camicie da notte, vestaglie e intimo per tutte le età e per
            tutte le tasche. Ampia scelta, prezzi bassi e la consulenza gentile
            di chi ti conosce da sempre.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <a
              href={shop.phoneHref}
              data-testid="hero-call-button"
              className="inline-flex items-center justify-center gap-2 bg-[#123D5B] hover:bg-[#0C2A40] text-white rounded-sm px-8 py-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(18,61,91,0.28)]"
            >
              <Phone size={18} aria-hidden="true" /> Chiama Ora
            </a>
            <a
              href={shop.mapsUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="hero-directions-button"
              className="inline-flex items-center justify-center gap-2 border border-[#123D5B]/15 text-[#123D5B] hover:border-[#C24E77] hover:text-[#C24E77] rounded-sm px-8 py-4 transition-all duration-300"
            >
              <MapPin size={18} aria-hidden="true" /> Vieni a trovarci
            </a>
          </div>

          <div className="mt-10 flex items-center gap-4">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  size={18}
                  className={i < 4 ? "fill-[#C24E77] text-[#C24E77]" : "fill-[#C24E77]/40 text-[#C24E77]/40"}
                  aria-hidden="true"
                />
              ))}
            </div>
            <p className="text-sm text-[#4A5863]">
              <span className="font-500 text-[#123D5B]">{shop.rating}</span> su
              Google · {shop.reviewsCount} recensioni
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="lg:col-span-6 relative"
        >
          <div className="relative rounded-2xl overflow-hidden border border-black/5 shadow-[0_24px_80px_rgba(45,40,37,0.14)]">
            <img
              src={images.hero}
              alt="Pigiama elegante in seta"
              className="w-full h-[440px] md:h-[560px] object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 hidden sm:block bg-[#FCFAFB] border border-black/5 rounded-xl px-6 py-5 shadow-[0_12px_40px_rgba(45,40,37,0.12)]">
            <p className="font-serif text-2xl text-[#C24E77] leading-tight">Per tutta<br />la famiglia</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
